<template>
  <LayoutDefault :show-side-bar="false">
    <QueueFilter @search="search"/>
    <div class="row d-flex flex-fill">
      <b-overlay :show="isLoading" class="col-lg-12 text-center">
        <h3>{{ $t('queue.title') }}</h3>        
      </b-overlay>
    </div>
    <div class="row">
      <div class="col-md-9 d-flex align-items-center">        
      </div>
      <CountDown v-if="filtro.sector_filter" class="col-md-3 justify-content-center"
                @time-over="search()"
                @refresh="search()"/>
    </div>
    <br/>
    <div>
      <b-card-group class="card-deck-two-line" deck>
        <b-card
          no-body
          header-tag="header"
          header-text-variant="secondary"
        >
          <template #header>
            <h5 class="mb-0"><i class="fa fa-arrow-up" /> {{ $t('queue.open_services') }}</h5>
          </template>

          <b-card-body>
            <div class="row">
              <MainQueueCard
                  v-for="(queueCard, key) in queue" :key="key"
                  v-if="!isLoading && key === 0"
                  variant="primary"
                  :badge="(key+1) + $t('queue.position')"
                  :name="queueCard.patient"
                  :date="queueCard.order_date | formatDate"
                  :recipients="queueCard.recipients"
                  :device="queueCard.device"
                  :sector="queueCard.sector"
                  :integrationDestination="queueCard.integration_destination"
                  class="shadow"
                  @realizeQueue="(device, recipients) => realizeQueue(device, recipients)"
              />
            </div>
            <div class="row">
                <QueueCard                    
                    v-for="(queueCard, key) in queue" :key="key"
                    v-if="!isLoading && key !== 0"
                    variant="primary"
                    :badge="(key+1) + $t('queue.position')"
                    :name="queueCard.patient"
                    :device="queueCard.device"
                    :date="queueCard.order_date | formatDate"
                    class="shadow"
                />                
            </div>
          </b-card-body>          
        </b-card>

        <b-card
          no-body
          header-tag="header"
          header-text-variant="secondary"
        >
          <template #header>
            <h5 class="mb-0"><i class="fa fa-check-square" /> {{ $t('queue.realized_services') }}</h5>
          </template>
          <b-card-body>            
            <div class="row">
                <QueueCard
                    v-for="(queueRealizedCard, key) in queueRealized" :key="key"
                    v-if="!isLoading"
                    :variant="queueRealizedVariant(queueRealizedCard)"
                    :badge="queueRealizedCard.recipient"
                    :name="queueRealizedCard.patient"
                    :device="queueRealizedCard.device"
                    :dateReport="queueRealizedCard.report_date | formatDate"
                    class="shadow"
                />
                <Loading v-else/>
            </div>
          </b-card-body>
        </b-card>
      </b-card-group>
    </div>
  </LayoutDefault>
</template>

<script>
import LayoutDefault from "@/templates/LayoutDefault";
import {mapActions, mapGetters} from "vuex";
import QueueFilter from "./QueueFilter";
import MainQueueCard from "@/components/MainQueueCard";
import QueueCard from "@/components/QueueCard";
import Loading from "@/components/Loading";
import QueueRepository from '@/repositories/vns/QueueRepository'
import CountDown from "@/components/CountDown";

export default {
  name: "index",
  components: {
    LayoutDefault,    
    QueueFilter,
    MainQueueCard,
    QueueCard,
    Loading,
    CountDown
  },
  computed: {
    ...mapGetters({
      queue: 'queue/all',
      queueRealized: 'queue/allRealized',
      isLoading: 'queue/isLoading',
      filtro: 'queueFilter/all'
    })
  },
  data() {
    return {
    }
  },
  methods: {
    ...mapActions([
      'queueFilter/setSpecific',
      'queueFilter/reset',
      'queue/service',
      'queue/realized',
    ]),
    queueRealizedVariant(queueRealizedCard) {
      return (queueRealizedCard.report_date === null) ? 'warning' : 'success' ;
    },
    search() {
      this.$store.commit('queue/setAll', [])
      this.$store.commit('queue/setAllRealized', [])

      if (this.filtro.sector_filter === null || this.filtro.sector_filter === undefined) {
        return
      }

      let filtroApi = {};
      filtroApi.company_id = this.filtro.company_filter;
      filtroApi.care_unit_id = this.filtro.care_unit_filter;
      filtroApi.sector_id = this.filtro.sector_filter;
      filtroApi.vns_id = this.filtro.vns_filter

      this['queue/service'](filtroApi)
      this['queue/realized'](filtroApi)
    },
    realizeQueue(device, recipients) {
      let params = {}
      params.device = device
      params.recipients = recipients

      QueueRepository.fetchRealize(params).then(() => {
        this.$snotify.success(this.$t('queue.realize.success'))
        this.search()
      }).catch(error => {
        this.$snotify.error(this.$t('queue.realize.error'))
      })
    }
  },
  async mounted() {
    await this['queueFilter/reset']()
  }
}
</script>

<style lang="scss" scoped>
h3 {
  font-weight: bold;
}

.card-deck-two-line {
  .card {
    //flex-grow: 0 !important;
    flex-shrink: 0 !important;
    flex-basis: calc(50% - 1.5rem) !important;
    margin-bottom: 1rem !important; /* mb-3 */
    @media (max-width: 1200px) {
      flex-basis: calc(100% - 1.5rem) !important;
    }
  }
}
</style>
